var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10V15C20 15.6566 19.8707 16.3068 19.6194 16.9134C19.3681 17.52 18.9998 18.0712 18.5355 18.5355C18.0712 18.9998 17.52 19.3681 16.9134 19.6194C16.3068 19.8707 15.6566 20 15 20H10C9.34339 20 8.69321 19.8707 8.08658 19.6194C7.47996 19.3681 6.92876 18.9998 6.46447 18.5355C6.00017 18.0712 5.63188 17.52 5.3806 16.9134C5.12933 16.3068 5 15.6566 5 15V10C5 8.67392 5.52678 7.40215 6.46447 6.46447C7.40215 5.52678 8.67392 5 10 5H15C16.3261 5 17.5979 5.52678 18.5355 6.46447C19.4732 7.40215 20 8.67392 20 10Z",
    fill: "#303037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50001 10V14.78C2.48335 14.4603 1.59545 13.8241 0.965831 12.9642C0.336211 12.1043 -0.00218496 11.0657 1.06168e-05 10V5C1.06168e-05 3.67392 0.526795 2.40215 1.46448 1.46447C2.40216 0.526784 3.67393 9.24669e-09 5.00001 9.24669e-09H10C11.064 -6.4682e-05 12.1004 0.339315 12.9582 0.968781C13.8161 1.59825 14.4508 2.48497 14.77 3.5H10C8.27692 3.50264 6.62515 4.18831 5.40674 5.40673C4.18833 6.62514 3.50266 8.2769 3.50001 10Z",
    fill: "#303037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/copy-dark.497aa6d3b8c989c78cd15ca4f8b335c1.svg";
export { ForwardRef as ReactComponent };